import React from 'react';
import { ToggleButton, ToggleButtonGroup, Box } from '@mui/material';

const PillOptionSelectorComponent = ({
  name,
  question,
  value,
  onChange,
  onNext,
  setValidationState,
  nextFieldRef,
  isMobile,
  layoutVariant = 'default',
}) => {
  const isAccountLayout = layoutVariant === 'account';
  const options = question.options || [];
  const mobileHeight = isAccountLayout ? '40px' : '25px';
  const mobileFontSize = isAccountLayout ? '0.75rem' : '0.4375rem';
  const mobilePadding = isAccountLayout ? '8px 14px' : '6px 12px';
  const mobileMinHeight = isAccountLayout ? '40px' : '25px';

  const handleChange = (event, val) => {
    if (!val) return;
    onChange(name, val);

    // validate and optionally advance
    if (question.validation?.required) {
      const isValid = !!val;
      setValidationState?.(name, isValid);
    }

    if (!question.disableAutoNext) {
      if (nextFieldRef?.current) {
        nextFieldRef.current.focus();
      } else {
        onNext?.();
      }
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: isMobile ? 'wrap' : 'nowrap',
        width: isMobile ? '100%' : 'fit-content',
        maxWidth: '100%',
        ml: 'auto',
        justifyContent: isAccountLayout && isMobile ? 'flex-end' : 'flex-start',
      }}
    >
      <ToggleButtonGroup
        value={value}
        exclusive
        onChange={handleChange}
        sx={{
          '& .MuiToggleButtonGroup-grouped': {
            borderRadius: 0,
            height: isMobile ? mobileHeight : '51px',
            border: '1px solid #D1D1D1',
            borderLeft: 'none',
            '&:first-of-type': {
              borderTopLeftRadius: '1.2rem',
              borderBottomLeftRadius: '1.2rem',
              borderLeft: '1px solid #D1D1D1',
            },
            '&:last-of-type': {
              borderTopRightRadius: '1.2rem',
              borderBottomRightRadius: '1.2rem',
            },
            fontFamily: 'Inter, sans-serif',
            fontWeight: 400,
            lineHeight: '100%',
            fontSize: isMobile ? mobileFontSize : '1rem',
            textTransform: 'none',
            color: '#757575',
            padding: isMobile ? mobilePadding : '8px 20px',
            '&.Mui-selected': {
              backgroundColor: '#C7CA00',
              color: '#1C2F3A',
              fontWeight: 600,
              '&:hover': {
                backgroundColor: '#B0B200',
              },
            },
          },
        }}
      >
        {options.map((opt, index) => (
          <ToggleButton
            key={index}
            value={opt}
            sx={{
              minHeight: isMobile ? mobileMinHeight : '51px',
            }}
          >
            {opt}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    </Box>
  );
};

export default PillOptionSelectorComponent;
